import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import Vicky from "../controls/Vicky";
import ReactDOMServer from "react-dom/server";
const CharacterContent = ({ getMyActivity }) => {
    console.log("CharacterContent : ", getMyActivity);
    return (
        <div className="">
            <div className="LessionDtlOverview">
                <p
                    dangerouslySetInnerHTML={{
                        __html: getMyActivity?.series?.charDesc && getMyActivity?.series?.charDesc,
                    }}
                />
                {/* <Vicky text={ReactDOMServer.renderToString(getMyActivity?.series?.charDesc)} /> */}
                {/* <div className="d-flex align-items-start flex-wrap">
                    <div className="flex w-100 mb-3 align-items-start flex-wrap text-justify textcontentSidebar">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: getMyActivity?.series?.charDesc && getMyActivity?.series?.charDesc,
                            }}
                        />
                    </div>
                    <Vicky text={getMyActivity?.series?.charDesc}/>
                </div> */}
                {/* <div className="Abotitems flextwo">
                    <div className="items_image mr-3">
                        <img src={image.userProfile} alt="character_image" className="br-50 " />
                    </div>
                    <div className="aboutitemsdtl">
                        <h4>Luca</h4>
                        <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                    </div>
                </div>
                <div className="Abotitems flextwo">
                    <div className="items_image mr-3">
                        <img src={image.userProfile} alt="character_image" className="br-50 " />
                    </div>
                    <div className="aboutitemsdtl">
                        <h4>Luca</h4>
                        <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                    </div>
                </div>
                <div className="Abotitems flextwo">
                    <div className="items_image mr-3">
                        <img src={image.userProfile} alt="character_image" className="br-50 " />
                    </div>
                    <div className="aboutitemsdtl">
                        <h4>Bella</h4>
                        <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                    </div>
                </div>
                <div className="Abotitems flextwo">
                    <div className="items_image mr-3">
                        <img src={image.userProfile} alt="character_image" className="br-50 " />
                    </div>
                    <div className="aboutitemsdtl">
                        <h4>Adrian</h4>
                        <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                    </div>
                </div>
                <div className="Abotitems flextwo">
                    <div className="items_image mr-3">
                        <img src={image.userProfile} alt="character_image" className="br-50 " />
                    </div>
                    <div className="aboutitemsdtl">
                        <h4>Josh</h4>
                        <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                    </div>
                </div> */}
            </div>
        </div>
    )
}
export default CharacterContent;